import api from "../../util/api";

export const editMediaItem = async (videoId, fieldToChange) => {
    return api
        .put(`v2/api/settings/videos/${videoId}`, {...fieldToChange})
        .then(({data: {result = ""}}) => {
            return {success: result === "success"};
        })
        .catch(err => {
            console.error(err);
        });
};

export const deleteMediaItem = async ({videoId, onSuccess, onError}) => {
    return api
        .delete(`v2/api/settings/videos/${videoId}`)
        .then(() => {
            onSuccess();
        })
        .catch(err => {
            onError();
        });
};

export const uploadMediaItemImage = async ({id, file, onSuccess, onError}) => {
    let formData = new FormData();
    const canvas = file.canvas;

    await new Promise((accept, reject) => {
        canvas.toBlob(blob => {
            formData.append("type", file.type);
            formData.append("files", blob);
            accept();
        }, "image/jpeg");
    });

    return api
        .post(`v2/api/videos/${id}/upload`, formData, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
            },
        })
        .then(({data}) => {
            if (data.result && data.result === "success") {
                onSuccess();
            } else {
                onError();
            }
        })
        .catch(err => {
            onError();
            console.error(err);
        });
};

export const deleteUploadedImage = (videoId, fileId) => {
    return api
        .delete(`v2/api/videos/${videoId}/delete/${fileId}`)
        .then(res => {
            return res;
        })
        .catch(err => {
            console.error(err);
        });
};
